/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

/* eslint-disable no-undef*/
export const onClientEntry = () => {};
/* eslint-enable no-undef */

// Prevent the page from scrolling to the top of the page after dismissing an Olapic modal
// https://github.com/gatsbyjs/gatsby/issues/11898
export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  if (location.hash) {
    return false;
  }

  const navigationTiming = performance.getEntriesByType("navigation");
  if (navigationTiming.length > 0 && navigationTiming[0].type !== "back_forward") {
    return false;
  }

  return true;
};
